module.exports = __webpack_public_path__ + "static/MapCtrlVid-107cd85bfe834d048ac72cac2ae9ae23.mp4";